import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { TSelectItem } from '../../../types/common';
import { BasicSelect } from './BasicSelect';

type TProps = {
  name: any;
  dataList: Array<TSelectItem>;
  title?: string;
  onChange?: () => void;
  className?: string;
};

export const SiteProcessSelectBox: React.VFC<TProps> = React.memo(
  (props: TProps) => {
    const { name, dataList = [], title, onChange, className } = props;

    // react-hook-formを使用する前提のcomponent
    const { register, control } = useFormContext();

    return (
      <Controller
        name={name}
        control={control}
        render={() => (
          <BasicSelect
            {...register(name)}
            onChange={onChange}
            className={className}
            disableUnderline
          >
            {title && <option>{title}</option>}
            {dataList.map(data => (
              <option value={data.value} key={data.value}>
                {data.label}
              </option>
            ))}
          </BasicSelect>
        )}
      />
    );
  }
);
